<template>
  <div>
    <v-btn
      small
      depressed
      color="secondary"
      class="white--text direct-file-upload-btn"
      :class="{ 'direct-file-upload-btn--icon-only': iconOnly }"
      :aria-label="iconOnly ? 'Upload files' : null"
      :title="iconOnly ? 'Upload files' : null"
      @click="$refs.mediaUpload.click()" 
    >
      <span v-if="!iconOnly">{{ title ? title : 'Browse' }}</span>
      <v-icon
        small
        :right="!iconOnly"
        dark
      >
        mdi-folder-open-outline
      </v-icon>
    </v-btn>
    <!-- File Upload -->
    <input
      type="file"
      name="media"
      style="display: none"
      ref="mediaUpload"
      id="fileToUpload"
      accept="image/*, .pdf, .ppt, .txt, .doc, .docx"
      @change="prepareUpload"
      :multiple="multiple || false"
    />
  </div>
</template>
<script>
import utils from '@/utils';
export default {
  name: 'DirectFileUpload',
  data () {
    return {
      uploadFiles: [],
      deleteObjectKeys: [],
      tmpImages: [],
      tmpFiles: [],
      actualMedias: []
    }
  },
  props: ['refresh', 'multiple', 'title', 'iconOnly'],
  watch: {
    refresh: function(newRefresh) {
      this.resetUpload()
    }
  },
  computed: {
    checkDisable() {
      if (!this.multiple) {
        return this.actualMedias.length > 0
      }
      return false
    }
  },
  methods: {
    async prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      const selectedMedias = []
      for (const element of uploadedFiles) {
        let mediaType = element.type.split('/')[0];
        // let fileType = element.name.split('.')[1];
        if (mediaType === 'image') {
          const buff = await this.readImage(element)
          let file = utils.func.dataURLtoFile(buff, element.name);
          this.actualMedias.push(file);
          selectedMedias.push(file)
          this.tmpImages.push({
            url: buff,
            src: buff,
            name: element.name
          })
        } else {
          this.tmpFiles.push(element);
          this.actualMedias.push(element);
          selectedMedias.push(element)
        }
      }
      e.target.value = '';
      this.updateMedias(selectedMedias)
    },
    readImage(file) {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => resolve(e.target.result);
      })
    },
    deleteImage(imgIndex) {
      let filename = this.tmpImages[imgIndex].name
      this.deleteObjectKeys.push(filename)
      this.tmpImages.splice(imgIndex, 1)
      let mediaIndex = this.actualMedias.findIndex(item => item.name === filename)
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1)
      this.updateMedias()
    },
    deleteFile(fileIndex) {
      let fileName = ''
      if (this.tmpFiles[fileIndex].name) {
        fileName = this.tmpFiles[fileIndex].name;
        this.deleteObjectKeys.push(fileName)
      }
      this.tmpFiles.splice(fileIndex, 1)
      let mediaIndex = this.actualMedias.findIndex(item => item.name === fileName)
      if (mediaIndex !== -1) this.actualMedias.splice(mediaIndex, 1)
      this.updateMedias()
    },
    updateMedias(medias) {
      this.$emit('setMedias', medias || this.actualMedias)
    },
    resetUpload() {
      this.uploadFiles = []
      this.deleteObjectKeys = []
      this.tmpImages = []
      this.tmpFiles = []
      this.actualMedias = []
    }
  }
}
</script>
<style scoped>
.direct-file-upload-btn--icon-only {
  min-width: 30px !important;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// DirectFileUpload.vue?1b68243a